import type { Space } from '@/features/spaces/interfaces/space.interface';

export interface PrivateSpaceState {
  /** The full private Space object for the current user. */
  privateSpace: Space | undefined;
}

export const initialPrivateSpaceState: PrivateSpaceState = {
  privateSpace: undefined,
};
